import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import StarekContext from "../context/StarekContext";
import Spinner from "../components/Spinner";

function SSOLogin() {
    const [searchParams] = useSearchParams();

    const starekContext = useContext(StarekContext);

    const navigate = useNavigate();
    const [message, setMessage] = useState(
        "Please wait while we sign you in..."
    );
    const [allowRelogin, setAllowRelogin] = useState(false);

    const [loading, setLoading] = useState(true);
    const didRun = useRef(false);
    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        async function handleSSOLogin() {
            try {
                const ssoPayload = Object.fromEntries(searchParams.entries());
                const { code, state } = ssoPayload;
                const { workspace, returnUriHost, returnUriPath } =
                    JSON.parse(state);
                const response = await starekContext.ssoLogin({
                    code,
                    workspace,
                    returnUriHost,
                    returnUriPath,
                });
                if (!response.token) {
                    throw new Error("No token received from IDP!");
                }

                navigate(returnUriPath || "/");
            } catch (e) {
                setAllowRelogin(true);
                setMessage("There was a problem signing in!");
            } finally {
                setLoading(false);
            }
        }
        handleSSOLogin();
    }, []);

    return (
        <div className="login-page">
            <div
                className="d-flex flex-column align-items-center justify-content-center text-white"
                style={{ minHeight: "60vh" }}
            >
                <h4>{message}</h4>
                <br />
                {loading && <Spinner />}
                {allowRelogin && (
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate("/login")}
                    >
                        Retry Login
                    </button>
                )}
            </div>
        </div>
    );
}

export default SSOLogin;
